/** @typedef {import('../../types/models').Wallet} Wallet */

import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { fetchCollectionsWallets } from '../../api';
import { handleQueryError } from '../../utils';

/** @returns {{ isLoading: boolean, wallets: Wallet[], walletsToDisplay: Wallet[] }} */
const useFetchCollectionsWallets = () => {
  const { tab } = useParams();
  const [wallets, setWallets] = useState([]);
  const [walletsToDisplay, setWalletsToDisplay] = useState(wallets);

  const { isLoading, data, isError, error } = useQuery(
    'allCollectionsWallets',
    fetchCollectionsWallets
  );
  if (isError) {
    handleQueryError(error, 'collection wallets');
  }
  useEffect(() => {
    if (data && data.data) {
      setWallets(data.data);
    } else {
      setWallets([]);
    }
  }, [data]);

  useEffect(() => {
    const filteredWallets = wallets.filter((wallet) => {
      const {
        currency: { type }
      } = wallet;
      if (!tab || tab === 'all' || tab === type?.toLowerCase()) return wallet;
    });
    setWalletsToDisplay(filteredWallets);
  }, [tab, wallets]);

  return { isLoading, wallets, walletsToDisplay };
};

export { useFetchCollectionsWallets };
